export default "__VITE_ASSET__DTQRrLQi__"